// extracted by mini-css-extract-plugin
export default {"card":"card_card__CS99L","card_img":"card_card_img__AFdZQ","vid":"card_vid__Cq3ns"};